export const calculateManagerRatings = ({
    // Runtime (editable step)
    runtimeAssessmentRating,
    runtimeGoalRating,
  
    // Submitted (this manager step)
    submittedAssessmentRating,
    submittedGoalRating,
  
    // Multi-level method results (all steps)
    methodAssessmentRating,
    methodGoalRating,
  
    ratingLabels = [],
    getRatingLabel
  }) => {
    const toNumber = (val) => {
      if (val === null || val === "" || Number.isNaN(Number(val))) return null;
      return Number(val);
    };
  
    const getCombined = (a, g) => {
      if (a != null && g != null) return (a + g) / 2;
      if (a != null) return a;
      if (g != null) return g;
      return null;
    };
  
    const getLabel = (rating) => {
      if (rating == null || !getRatingLabel) return "";
      return getRatingLabel(rating, ratingLabels || []);
    };
  
    // 1. Runtime Ratings (while editing)
    const runtimeAssessment = toNumber(runtimeAssessmentRating);
    const runtimeGoal = toNumber(runtimeGoalRating);
    const runtimeCombined = getCombined(runtimeAssessment, runtimeGoal);
  
    // 2. Submitted Ratings (this manager step)
    const submittedAssessment = toNumber(submittedAssessmentRating);
    const submittedGoal = toNumber(submittedGoalRating);
    const submittedCombined = getCombined(submittedAssessment, submittedGoal);
  
    // 3. Multi-Level Final (all steps + rating method)
    const methodAssessment = toNumber(methodAssessmentRating);
    const methodGoal = toNumber(methodGoalRating);
    const finalCombinedMethod = getCombined(methodAssessment, methodGoal);
  
    return {
      runtime: {
        assessment: runtimeAssessment,
        goal: runtimeGoal,
        combined: runtimeCombined,
        combinedLabel: getLabel(runtimeCombined)
      },
      submitted: {
        assessment: submittedAssessment,
        goal: submittedGoal,
        combined: submittedCombined,
        combinedLabel: getLabel(submittedCombined)
      },
      final: {
        assessment: methodAssessment,
        goal: methodGoal,
        combined: finalCombinedMethod,
        combinedLabel: getLabel(finalCombinedMethod)
      }
    };
  };
  